// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_ea-2";
export var aiChatCartContainerExit = "_ea-4";
export var aiChatContainerLarge = "_ea-0";
export var aiChatContainerSmall = "_ea-1";
export var aiChatIcon = "_ea-6";
export var slideInFromRight = "_ea-3";
export var slideOutToRight = "_ea-5";